<div class="popup g-popup"
     (cmsEscapeKey)="closePopup()">
    <header class="g-popup-header">
        <i (click)="closePopup()"
           class="g-popup-header-close g-icon g-icon-close-a"></i>
        <div class="g-popup-title">
            {{'settings_new_application_template_setting' | translate}}
        </div>
    </header>
    <div class="g-popup-body">
        <form class="popup-form"
              novalidate
              [formGroup]="form"
              (ngSubmit)="onSubmit(form)">
            <div class="form-body">
                <div class="form-control">
                    <cms-select formControlName="appTemplate"
                                [options]="appTemplates"
                                [title]="'applications_application_template' | translate"
                                [placeholder]="'applications_application_template' | translate">
                    </cms-select>
                </div>
                <div class="form-control">
                    <div class="g-input g-input-io"
                         [ngClass]="{invalid: form.get('key').invalid && !form.get('key').pristine}">
                        <input type="text"
                               class="g-input-input"
                               [placeholder]="'common_key' | translate"
                               formControlName="key">
                        <label class="g-input-label">{{'common_key' | translate}}</label>
                        <label class="g-input-validation">
                            <span *ngIf="form.get('key').hasError('required')">
                                {{ 'common_validation_field_required' | translate }}
                            </span>
                            <span *ngIf="form.get('key').hasError('maxlength') && !form.get('key').hasError('pattern')">
                                {{'common_validation_maximum_field_length' | translate: keyValidationInterpolationParams}}
                            </span>
                            <span *ngIf="form.get('key').hasError('pattern')">
                                {{'common_validation_valid_characters' | translate: keyValidationInterpolationParams}}
                            </span>
                        </label>
                    </div>
                </div>
                <div class="form-control">
                    <cms-select formControlName="type"
                                [options]="settingTypes"
                                [title]="'common_type' | translate"
                                [placeholder]="'common_type' | translate"
                                (selectChanged)="onSelectChanged($event)">
                    </cms-select>
                </div>
                <div class="form-control">
                    <div class="g-input g-input-io"
                         [ngClass]="{invalid: form.get('value').invalid
                                    && !form.get('value').pristine}">
                        <ng-container *ngIf="form.value.type?.id !== 'object' &&
                                             form.value.type?.id !== 'config'">
                            <input type="text"
                                   class="g-input-input"
                                   [placeholder]="'common_value' | translate"
                                   formControlName="value">
                            <label class="g-input-label">
                                {{'common_value' | translate}}
                            </label>
                        </ng-container>
                        <json-editor *ngIf="form.value.type?.id === 'object' ||
                                             form.value.type?.id === 'config'"
                                     formControlName="value">
                        </json-editor>
                       
                        <label class="g-input-validation"
                               *ngIf="form.get('value').hasError('jsonParseError')">
                            {{'common_validation_parse_error' | translate}}
                        </label>

                        <label class="g-input-validation" *ngIf="!form.get('value').hasError('jsonParseError') && form.get('value').hasError('required')">
                            {{'common_validation_field_required' | translate}}
                        </label>
                    </div>
                </div>
            </div>
            <div class="form-footer">
                <div class="form-footer-buttons">
                    <button type="submit"
                            class="form-footer-button g-button g-button-earth"
                            [disabled]="form.invalid">
                        <span class="g-button-title">
                            {{ 'common_save' | translate }}
                        </span>
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
